<template>
  <b-overlay :show="loading">
    <b-row v-if="mode == `add`">
      <b-col v-if="byOperator" cols="12" md="12">
        <b-form-group
          :label="$lang.ticketLang.chosse_case"
          label-for="user"
          :label-cols="$config.form.labelCol"
        >
          <requiredComponent
            slot="label"
            :label="$lang.ticketLang.chosse_case"
            :rules="$v.user_selected.$params"
          />
          <selectAsync
            :options="user_options"
            v-model="$v.user_selected.$model"
            label="text"
            id="value"
            :asyncFind="getUsers"
            :isValid="$v.user_selected.$dirty ? !$v.user_selected.$error : null"
            :loading="userLoading"
          />
          <b-form-invalid-feedback id="user-feedback"
            >{{ $lang.error_required | replace($lang.ticketLang.chosse_case) }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="12">
        <b-form-group
          :label="$lang.ticketLang.subject"
          label-for="subject"
          :label-cols="$config.form.labelCol"
        >
          <requiredComponent
            slot="label"
            :label="$lang.ticketLang.subject"
            :rules="$v.subject.$params"
          />
          <b-form-input
            id="subject"
            type="text"
            autocomplete="off"
            v-model="$v.subject.$model"
            :state="$v.subject.$dirty ? !$v.subject.$error : null"
          >
          </b-form-input>
          <b-form-invalid-feedback id="subject-feedback"
            >{{ $lang.error_required.replace("{0}", $lang.ticketLang.subject) }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12">
        <b-form-group
          :label="
            isProtestTicket
              ? $lang.ticketLang.message_label_protest_ticket
              : $lang.ticketLang.message
          "
          :label-cols="12"
        >
          <requiredComponent
            :label="
              isProtestTicket
                ? $lang.ticketLang.message_label_protest_ticket
                : $lang.ticketLang.message
            "
            slot="label"
            :rules="$v.description.$params"
          />
          <b-form-textarea
            id="description"
            v-model="$v.description.$model"
            type="text"
            :rows="4"
            :state="$v.description.$dirty ? !$v.description.$error : null"
          >
          </b-form-textarea>
          <b-form-invalid-feedback id="description-feedback">
            {{ $lang.error_required.replace("{0}", $lang.ticketLang.message) }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col v-if="!showUpload" cols="12" md="12" class="mt-2">
        <label v-text="$lang.send_file" />
        <fileDrag
          ref="fileDrag"
          @uploadFile="attachmentTemp"
          :acceptFormats="acceptFormats"
          :acceptFormatsInput="acceptFormatsInput"
          :multiple="true"
          :crop="false"
        />
        <filelistPorgress
          :fileUpload="fileUpload"
          @removeFile="removeFileProgress"
          @getResponseCode="filesCode"
          :showButton="false"
          :attachmentTypeId="22"
        />
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col cols="12" class="text-right">
        <b-overlay
          :show="loading"
          spinner-small
          spinner-variant="primary"
          class="d-inline-block"
        >
          <b-button
            variant="success"
            @click="submit"
            :disabled="isUserHaveTicket"
          >
            {{ $lang.submitButton }}
            <i class="fa fa-check" />
          </b-button>
        </b-overlay>
        <b-button
          type="reset"
          class="ml-2"
          size="md"
          variant="danger"
          @click="cancel"
        >
          <i class="fa fa-ban"></i>
          {{ $lang.cancelButton }}
        </b-button>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>
import { required, requiredIf } from "vuelidate/lib/validators";
import fileDrag from "@/components/fileManager/fileDrag";
import filelistPorgress from "@/components/fileManager/filelistPorgress";
import { pathOr } from "ramda";
export default {
  props: {
    mode: {
      type: String,
      default: "add",
    },
    item: {
      type: Object,
    },
    showUpload: {
      type: Boolean,
      default: false,
    },
    byOperator: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    fileDrag,
    filelistPorgress,
  },
  validations: {
    user_selected: {
      requiredIf: requiredIf((vm) => {
        return vm.byOperator;
      }),
    },
    subject: {
      required,
    },
    description: {
      required,
    },
  },
  data() {
    return {
      isProtestTicket: this.$route.name === "add_protest_ticket",
      file_types: ["image", "office", "media", "other"],
      loading: false,
      user_selected: null,
      user_options: [],
      userLoading: false,
      subject: null,
      description: null,
      itemId: null,
      isUserHaveTicket: false,
      fileUpload: [],
      acceptFormatsInput: "",
      acceptFormats: [
        {
          caption: "عکس",
          value: "1MB",
        },
        {
          caption: "مجموعه آفیس",
          value: "1MB",
        },
      ],
      responseCode: [],
    };
  },
  methods: {
    pathOr,
    cancel() {
      this.$emit("cancel");
    },
    async getUsers(searchText) {
      if (!searchText || searchText.length < 3) {
        this.user_options = [];
        return;
      }

      try {
        this.userLoading = true;
        let url =
          this.$config.api_url + this.$config.ticket.user_parvandeh_combo;
        let params = {
          search_txt: searchText,
        };
        const response = await this.$httpService.get(url, params);
        let data = pathOr([], ["data", "data"], response);
        this.user_options = data.map((item) => {
          const { family, name, national_code } = item.person;
          const { parvandeh_number, parvandeh_code } = item;
          return {
            value: parvandeh_code,
            text: `${parvandeh_number} ${family} ${name} ${national_code}`,
          };
        });
      } catch (error) {
        this.person_options = [];
      } finally {
        this.userLoading = false;
      }
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$anyError) {
        return;
      }

      const userPayload = {
        ticket_subject: this.subject,
        ticket_unit_id: 1,
        description: this.description,
      };
      if (this.byOperator)
        userPayload.parvandeh_code =
          this.user_selected && this.user_selected.value;
      this.$emit("submit", userPayload);
    },
    removeFileProgress(item) {
      let indexFile = this.fileUpload.indexOf(item);
      let response = this.responseCode.find((x) => x.name == item.name);
      let indexResponse = this.responseCode.indexOf(response);
      this.fileUpload.splice(indexFile, 1);
      this.responseCode.splice(indexResponse, 1);
      this.$refs.fileDrag.$refs.fileupload.value = "";
    },
    filesCode(code) {
      this.responseCode = code;
      this.$emit("responseCode", this.responseCode);
    },
    attachmentTemp(files) {
      this.btnHidden = true;
      this.fileUpload = [...this.fileUpload, ...files];
    },
    async checkUserHaveTicket() {
      try {
        const url =
          this.$config.api_url +
          this.$config.ticket.ticket_unit_id.replace("{0}", 1);
        await this.$httpService.get(url);
      } catch (error) {
        this.$generateError(error);
        this.isUserHaveTicket = true;
      }
    },
  },
  created() {
    if (!this.byOperator) {
      this.checkUserHaveTicket();
    }
  },
};
</script>
